import { Icon } from "@iconify/react";
import React from 'react';
import { useNavigate } from "react-router-dom";

const LogoutHandler = (props) => {

    const navigate = useNavigate();

    function handleLogoutClick() {

        localStorage.removeItem('sessionId');
        navigate("/" + props.officeName + "/login/");

    }

    return (
        <li className="menu-item logout-item" onClick={() => handleLogoutClick()}>
            <Icon icon="mingcute:exit-fill" className="icon" />
            <span className="menu-text">Se déconnecter</span>
        </li>
    );

}

export default LogoutHandler;